import { getLimitConfiguration } from './get-limit-configuration';
import { MakeUpdateLimitOperation } from './types';

export const makeUpdateLimitOperation: MakeUpdateLimitOperation = (
  configurationId,
  values,
  limitType,
  limitScope,
) => ({
  name: 'limitUpdate',
  variables: {
    input: {
      id: configurationId,
      configuration: getLimitConfiguration(limitScope, values, limitType),
    },
  },
});
